import React, { FC } from 'react';
import { OnSelectFamilyCrestColor, OrderPartsImg } from '@app/react/uikit';
import {
    FamilycrestSelectPanel,
    FamilycrestList,
} from '@component/Familycrest';
import {
    GetResponseFamilyCrestColors,
    GetResponseOrderParts,
    PartsProduct,
    FamilyCrestColor,
} from '@app/react/const/type';
import { useMediaDesktop } from '@app/react/common/useMedia';
import { KamonBodyDesktopComponent } from '@component/PartsSelectComponent/KamonBodyDesktopComponent';
import { KamonBodyMobileComponent } from '@component/PartsSelectComponent/KamonBodyMobileComponent';
import { OrderSelectBaseLayout } from '@component/OrderSelectBaseLayout';
import { OrderPartsHelpFamilycrest } from '@component/OrderPartsHelp';
import { FamilycrestCantSelectDialogContainer } from '@container/Dialog';

const partsNameProps = '家紋（羽の中）';

export interface IOrderKamonComponent {
    onCustomizeClick: () => void;
    noProduct: PartsProduct;
    yesProduct: PartsProduct;
    familycrestData: GetResponseOrderParts | null;
    familycrestColorsData: GetResponseFamilyCrestColors | null;
    familycrestOk: boolean;
    familycrest: PartsProduct | null;
    familycrestColor: FamilyCrestColor | null;
    onClickNoProduct: () => void;
    onClickYesProduct: () => void;
    onSelectProduct: (
        event: React.MouseEvent<HTMLButtonElement, MouseEvent>,
        product: PartsProduct
    ) => void;
    onSelectFamilyCrestColor: OnSelectFamilyCrestColor;
    isPanel: boolean;
    showPanel: () => void;
    hidePanel: () => void;
    isHelpOpen: boolean;
    handleHelpOpen: () => void;
    handleHelpClose: () => void;
}

export const OrderKamonComponent: FC<IOrderKamonComponent> = (props) => {
    const {
        onCustomizeClick,
        noProduct,
        yesProduct,
        familycrestData,
        familycrestColorsData,
        familycrestOk,
        familycrest,
        familycrestColor,
        onSelectProduct,
        onSelectFamilyCrestColor,
        onClickNoProduct,
        onClickYesProduct,
        isPanel,
        showPanel,
        hidePanel,
        isHelpOpen,
        handleHelpOpen,
        handleHelpClose,
    } = props;

    const isDesktop = useMediaDesktop();

    const bodyComponent = isDesktop ? (
        <KamonBodyDesktopComponent
            noProduct={noProduct}
            yesProduct={yesProduct}
            familycrestColorsData={familycrestColorsData}
            familycrestOk={familycrestOk}
            familycrest={familycrest}
            familycrestColor={familycrestColor}
            onSelectFamilyCrestColor={onSelectFamilyCrestColor}
            onClickNoProduct={onClickNoProduct}
            onClickYesProduct={onClickYesProduct}
            showPanel={showPanel}
        />
    ) : (
        <KamonBodyMobileComponent
            onCustomizeClick={onCustomizeClick}
            noProduct={noProduct}
            yesProduct={yesProduct}
            familycrestColorsData={familycrestColorsData}
            familycrestOk={familycrestOk}
            familycrest={familycrest}
            familycrestColor={familycrestColor}
            onSelectFamilyCrestColor={onSelectFamilyCrestColor}
            onClickNoProduct={onClickNoProduct}
            onClickYesProduct={onClickYesProduct}
            showPanel={showPanel}
        />
    );

    return (
        <>
            <OrderSelectBaseLayout
                type={1}
                header={isDesktop && (
                    <OrderPartsImg
                        partsName={partsNameProps}
                        showHelpBtn
                        onHelpClick={handleHelpOpen}
                    />
                )}
                body={bodyComponent}
            >
                <FamilycrestCantSelectDialogContainer />
            </OrderSelectBaseLayout>
            <FamilycrestSelectPanel isOpen={isPanel} handleClose={hidePanel}>
                <FamilycrestList
                    selectable
                    value={familycrest}
                    items={familycrestData?.partsData || []}
                    onClick={onSelectProduct}
                />
            </FamilycrestSelectPanel>
            <OrderPartsHelpFamilycrest
                isOpen={isHelpOpen}
                handleOpen={handleHelpOpen}
                handleClose={handleHelpClose}
            />
        </>
    );
};
